import { atomWithStorage } from "jotai/utils";

export const friendListAtom = atomWithStorage("WOG_profile_friends", []);
